module.exports = __webpack_public_path__ + "static/media/caseStudyIcon.e3b5b990.svg";